import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Avatar from 'components/Avatar';
import ReactGA from 'react-ga';
import moment from 'moment';
import apiFetch from 'utils/apiFetch';
import history from 'store/history';
import { ROUTE_INITIATIVES } from 'constants/urls';
import SpeedDatingIcon from 'assets/images/icons/speed_dating_icon.svg';
import speedDatingLogo from 'assets/images/hall/speedDatingLogoGreen.svg';
import { FinishSpeedDatingWrapper } from './styles';


class FinishSpeedDating extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasConnect: false,
    };
  }

  goHome = () => {
    const { onClose } = this.props;
    history.push(ROUTE_INITIATIVES);

    if (onClose) {
      onClose();
    }
  }

  handleClose = () => {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }
  }

  handleShowProfile = () => {
    const { onShowProfile } = this.props;

    if (onShowProfile) {
      onShowProfile(this.getOtherUserId());
    }
  }

  getOtherUserId = () => {
    const { users: usersStr, actualUser } = this.props;

    const users = typeof usersStr === 'string' ? JSON.parse(usersStr) : usersStr;

    const user1 = parseInt(users[0].id, 10);
    const user2 = parseInt(users[1].id, 10);
    const otherUser = (actualUser.id === user1 ? user2 : user1);

    return otherUser;
  }

  getOtherUser = () => {
    const { users: usersStr, actualUser } = this.props;

    const users = typeof usersStr === 'string' ? JSON.parse(usersStr) : usersStr;

    const user1 = parseInt(users[0].id, 10);
    const otherUser = (actualUser.id === user1 ? users[1] : users[0]);

    return otherUser;
  }

  connect = () => {
    const { addRequestedConnection } = this.props;
    const otherUser = this.getOtherUserId();
    const params = {
      userId: otherUser,
      action: 'connect',
    };

    apiFetch('POST', { endPoint: 'users/connection' }, params);
    addRequestedConnection({ id: otherUser });
    ReactGA.event({
      category: 'Add Connection User',
      action: `user_${otherUser}`,
      label: 'Feedback Step',
    });

    this.setState({ hasConnect: true });
  }

  render() {
    const {
      literals, myNetwork, requestConnections, actualUser, startDate,
    } = this.props;
    const { hasConnect } = this.state;

    const otherUser = this.getOtherUser();


    let subtitle = `${literals.speedDatingFeedbackSubTitle1} ${otherUser.firstname} ${otherUser.lastname} ${literals.speedDatingFeedbackSubTitle2}`;
    let footer = (
      <div className='bottom_grid'>
        <div>
          <button className='primary black' onClick={this.handleClose}>{literals.notNow}</button>
        </div>
        <div>
          <button className='primary' onClick={this.connect}>{literals.proposeToConnect}</button>
        </div>
      </div>
    );

    if (hasConnect) {
      footer = (
        <div className='success_msg'>
          {literals.proposeConnectHasBeenSent}
        </div>
      );
    } else if (_.find(myNetwork, { id: otherUser.id })) {
      footer = null;
      subtitle = `${otherUser.firstname} ${otherUser.lastname} ${literals.isAlreadyInYourNetwork}`;
    } else if (_.find(requestConnections, { id: otherUser.id })) {
      footer = null;
      subtitle = `${otherUser.firstname} ${otherUser.lastname} ${literals.hasNotYetAcceptedConnectionProposal}`;
    }

    return (
      <FinishSpeedDatingWrapper>
        <div className='users'>
          <div>
            <Avatar id={otherUser.id} avatar={otherUser.avatar} firstname={otherUser.firstname} size={80} />
          </div>
          <img src={SpeedDatingIcon} alt='' className='speed_dating_icon' />
          <div>
            <Avatar id={actualUser.id} avatar={actualUser.avatar} firstname={actualUser.firstname} size={80} />
          </div>
        </div>
        <div className='title'>{literals.speedDatingFeedbackTitle}</div>
        <div className='subtitle'>{subtitle}</div>
        <div className='central_grid'>
          <div>
            <div className='speed_card'>
              <div className='header'>
                <div className='icon'>
                  <img src={speedDatingLogo} alt='' />
                </div>
                <div className='data'>
                  {moment(startDate, 'X').format('MMMM Do')}
                </div>
              </div>
              <div className='body'>
                <Avatar id={otherUser.id} avatar={otherUser.avatar} firstname={otherUser.firstname} size={32} />
                <div className='user_name'>{`${otherUser.firstname} ${otherUser.lastname}`}</div>
              </div>
            </div>
          </div>
          <div>
            <button className='primary white' onClick={this.handleShowProfile}>{literals.viewProfile}</button>
          </div>
        </div>
        {footer}
      </FinishSpeedDatingWrapper>
    );
  }
}

FinishSpeedDating.propTypes = {
  literals: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  startDate: PropTypes.number.isRequired,
  addRequestedConnection: PropTypes.func.isRequired,
  myNetwork: PropTypes.array,
  requestConnections: PropTypes.array,
  actualUser: PropTypes.object,
  onClose: PropTypes.func,
  onShowProfile: PropTypes.func,
};

FinishSpeedDating.defaultProps = {
  actualUser: { id: 0 },
  onClose: null,
  onShowProfile: null,
  myNetwork: [],
  requestConnections: [],
};

export default FinishSpeedDating;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/FinishSpeedDating/components/index.jsx